module.exports = __webpack_public_path__ + "img/qiuzhizhe.4acef88b.png";